var __defProp = Object.defineProperty,
  __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty,
  __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value
  }) : obj[key] = value,
  __spreadValues = (a, b) => {
    for (var prop in b || (b = {})) __hasOwnProp.call(b, prop) && __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) __propIsEnum.call(b, prop) && __defNormalProp(a, prop, b[prop]);
    return a;
  },
  __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) __hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0 && (target[prop] = source[prop]);
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop) && (target[prop] = source[prop]);
  return target;
};
import * as React from "react";
import { Box, safelySpreadBoxProps } from "@twilio-paste/box";
var Option = React.forwardRef((_a, ref) => {
  var _b = _a,
    {
      children,
      element = "OPTION"
    } = _b,
    props = __objRest(_b, ["children", "element"]);
  return props.selected && console.warn('"selected" is a blocked prop on this component, please use "value" on the select element.'), React.createElement(Box, __spreadProps(__spreadValues({
    as: "option",
    ref
  }, safelySpreadBoxProps(props)), {
    element,
    size: void 0,
    height: void 0,
    width: void 0,
    backgroundColor: "inherit",
    color: "inherit",
    fontFamily: "inherit",
    lineHeight: "lineHeight50",
    paddingTop: "space30",
    paddingBottom: "space30",
    paddingLeft: "space20"
  }), children);
});
Option.displayName = "Option";
import * as React2 from "react";
import { Box as Box2, safelySpreadBoxProps as safelySpreadBoxProps2 } from "@twilio-paste/box";
var OptionGroup = React2.forwardRef((_a, ref) => {
  var _b = _a,
    {
      label,
      children,
      element = "OPTION_GROUP"
    } = _b,
    props = __objRest(_b, ["label", "children", "element"]);
  return React2.createElement(Box2, __spreadProps(__spreadValues({
    ref,
    label
  }, safelySpreadBoxProps2(props)), {
    element,
    as: "optgroup",
    backgroundColor: "inherit",
    color: "inherit",
    fontFamily: "inherit",
    fontWeight: "fontWeightMedium",
    fontStyle: "normal",
    margin: "space20"
  }), children);
});
OptionGroup.displayName = "OptionGroup";
import * as React3 from "react";
import { Box as Box3, safelySpreadBoxProps as safelySpreadBoxProps3 } from "@twilio-paste/box";
import { ChevronDownIcon } from "@twilio-paste/icons/esm/ChevronDownIcon";
import { InputBox, InputChevronWrapper, getInputChevronIconColor } from "@twilio-paste/input-box";
var SelectElement = React3.forwardRef((_a, ref) => {
  var _b = _a,
    {
      element = "SELECT_ELEMENT",
      variant,
      size
    } = _b,
    props = __objRest(_b, ["element", "variant", "size"]);
  return React3.createElement(Box3, __spreadProps(__spreadValues({}, safelySpreadBoxProps3(props)), {
    element,
    as: "select",
    ref,
    size,
    height: void 0,
    appearance: "none",
    backgroundColor: variant === "inverse" ? "colorBackgroundInverse" : "colorBackgroundBody",
    border: "none",
    borderRadius: "borderRadius20",
    boxShadow: "none",
    color: "inherit",
    cursor: "pointer",
    display: "block",
    fontFamily: "inherit",
    fontSize: "fontSize30",
    fontWeight: "fontWeightMedium",
    lineHeight: "lineHeight20",
    margin: "space0",
    outline: "none",
    paddingBottom: "space30",
    paddingLeft: "space40",
    paddingRight: "space100",
    paddingTop: "space30",
    resize: "none",
    width: "100%",
    _disabled: {
      color: variant === "inverse" ? "colorTextInverseWeaker" : "colorTextWeaker",
      cursor: "not-allowed",
      opacity: 1
    },
    variant
  }));
});
SelectElement.displayName = "SelectElement";
var Select = React3.forwardRef((_a, ref) => {
  var _b = _a,
    {
      disabled,
      element = "SELECT",
      hasError,
      insertBefore,
      insertAfter,
      children,
      size,
      multiple,
      variant = "default"
    } = _b,
    props = __objRest(_b, ["disabled", "element", "hasError", "insertBefore", "insertAfter", "children", "size", "multiple", "variant"]);
  return React3.createElement(InputBox, {
    disabled,
    element,
    hasError,
    insertAfter,
    insertBefore,
    variant
  }, React3.createElement(Box3, {
    display: "flex",
    width: "100%",
    position: "relative"
  }, React3.createElement(SelectElement, __spreadProps(__spreadValues({
    "aria-invalid": hasError,
    "data-not-selectize": "true",
    disabled,
    ref,
    element: `${element}_ELEMENT`
  }, props), {
    multiple,
    size: multiple ? size : 0,
    variant
  }), children), !multiple && React3.createElement(InputChevronWrapper, {
    element: `${element}_CHEVRON_WRAPPER`
  }, React3.createElement(ChevronDownIcon, {
    "aria-hidden": "true",
    decorative: !0,
    element: `${element}_ICON`,
    color: getInputChevronIconColor(variant, disabled, !1),
    size: "sizeIcon30"
  }))));
});
Select.displayName = "Select";
export { Option, OptionGroup, Select, SelectElement };